/**
 * Settings translation keys
 * Contains all translation strings for settings-related UI elements
 */

module.exports = {
  general_settings: {
    title: "admin.settings_general_settings_title",
    header_logo: "admin.settings_header_logo_label",
    favicon_logo: "admin.settings_favicon_logo_label", 
    login_page_logo: "admin.settings_login_page_logo_label",
    email_logo: "admin.settings_email_logo_label",
    ios_version_label: "admin.settings_ios_version_label",
    android_version_label: "admin.settings_android_version_label",
    admin_email_label: "admin.settings_admin_email_label",
    contact_email_label: "admin.settings_contact_email_label",
    premium_grant_months_label: "admin.settings_premium_grant_months_label",
    premium_auto_grant_label: "admin.settings_premium_auto_grant_label",
    premium_auto_grant_active: "admin.settings_premium_auto_grant_active",
    premium_auto_grant_inactive: "admin.settings_premium_auto_grant_inactive",
    premium_auto_grant_blocked: "admin.settings_premium_auto_grant_blocked",
    no_logo_set: "admin.settings_no_logo_set",
    update_success: "admin.settings_update_success",
    update_failed: "admin.settings_update_failed"
  },

  validation: {
    header_logo_required: "admin.settings_header_logo_required",
    email_logo_required: "admin.settings_email_logo_required",
    favicon_logo_required: "admin.settings_favicon_logo_required",
    login_page_logo_required: "admin.settings_login_page_logo_required",
    ios_version_required: "admin.settings_ios_version_required",
    android_version_required: "admin.settings_android_version_required",
    contact_email_required: "admin.settings_contact_email_required",
    invalid_email_format: "admin.settings_invalid_email_format",
    invalid_file_format: "admin.settings_invalid_file_format",
    invalid_version_format: "admin.settings_invalid_version_format",
    version_max_length: "admin.settings_version_max_length",
    version_numbers_only: "admin.settings_version_numbers_only"
  },

  referral_settings: {
    title: "admin.referral_settings_title",
    milestone_size_label: "admin.referral_settings_milestone_size_label",
    months_per_milestone_label: "admin.referral_settings_months_per_milestone_label",
    consecutive_days_label: "admin.referral_settings_consecutive_days_label",
    min_messages_label: "admin.referral_settings_min_messages_label",
    update_success: "admin.referral_settings_update_success",
    update_failed: "admin.referral_settings_update_failed"
  },

  page_title: "admin.settings_page_title"
};
